const headers = {
  headlineCareTeam: 'Care team',
  headlineCarePlan: 'Care plan',
};

export const defaultGlobalContent = { ...headers };
export type ContentKeys = keyof typeof defaultGlobalContent;
